module.exports = __webpack_public_path__ + "img/close.6e64b8a9.svg";